export default __webpack_public_path__ + "static/press-6f8858b128809b8a3004428fbc29ebc5.png";